import { render, staticRenderFns } from "./toper.vue?vue&type=template&id=c166c7c8&scoped=true&"
import script from "./toper.vue?vue&type=script&lang=js&"
export * from "./toper.vue?vue&type=script&lang=js&"
import style0 from "./toper.vue?vue&type=style&index=0&id=c166c7c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c166c7c8",
  null
  
)

export default component.exports